import { teal } from "@mui/material/colors";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import * as DefaultRoutes from "@Routes/DefaultRoutes";
import GenericHomePage from "../../GenericHomePage/GenericHomePage";
import FactCheckRoundedIcon from "@mui/icons-material/FactCheckRounded";

const WareHouseHomePage = () => {
  const navigate = useNavigate();

  const theme = useTheme();
  let sectionsBox = [
    {
      textBeside: "All Released Orders",
      icon: FactCheckRoundedIcon,
      iconColor: teal[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: teal[50],
      onClick: () => navigate(DefaultRoutes.allReleasedOrders),
      size: 12,
    },
  ];
  return <GenericHomePage sectionsBox={sectionsBox} />;
};
export default WareHouseHomePage;
